import { debounce } from "lodash";
import { observer } from "mobx-react-lite";
import { useCallback, useContext, useEffect, useState } from "react";
import { getDeliveryAddress } from "../../http/basketApi";
import { Context } from "../../index";
import InputUI from "../UI/Input/Input";
import Suggestions from "../UI/Suggestions/Suggestions";
import './styles.scss';

const AddressInput = observer(({ text, value, onChange, onChangeAddress, disabled, withoutDadata = false }) => {
  const { basket, delivery } = useContext(Context);

  const [localValue, setLocalValue] = useState(withoutDadata ? delivery?.cityInfo?.value : '');
  const [suggestions, setSuggestions] = useState([]);
  const [debouncedValue, setDebouncedValue] = useState('');

  const debouncedInput = useCallback(
    debounce((val) => {
      setDebouncedValue(val);
    }, 300),
    []
  );

  useEffect(() => {
    if (value !== undefined && value !== localValue) {
      setLocalValue(value);
    }
  }, [value]);

  useEffect(() => {
    if (value !== localValue) {
      onChange?.(localValue);
    }
  }, [localValue]);

  useEffect(() => {
    if (debouncedValue.trim().length === 0) {
      setSuggestions([]);
      delivery.setAddressValidShield('');
      return;
    }

    if (withoutDadata) {
      handleItemAddress({
        ...delivery?.cityInfo,
        ...{
          value: debouncedValue
        }
      })
      return;
    }

    getDeliveryAddress(delivery?.cityInfo?.value ?? 'Москва', debouncedValue).then(response => {
      basket.setOrderSearchQuery(debouncedValue);

      delivery.setAddressValidShield('');

      if (!response.length) {
        delivery.setAddressValidShield("Пожалуйста, укажите корректный адрес");
        setSuggestions([]);
        return;
      }

      const hasHouse = !!response[0].data.house;
      delivery.setAddressValidShield(hasHouse ? '' : 'Укажите дом');
      setSuggestions(response.map(item => ({
        id: item.value,
        text: item.value,
        data: item
      })));
    });
  }, [debouncedValue]);

  useEffect(() => {
    if (!delivery.searchAddress) return;

    const hasHouse = !!(delivery.searchAddress && delivery.searchAddress.data.house);

    delivery.setAddressValidShield(hasHouse ? '' : 'Укажите дом');

    if (delivery.searchAddress) {
      setLocalValue(delivery.searchAddress.value)
    }

    if (hasHouse) {
      handleItemAddress(delivery.searchAddress)
    }
  }, [delivery.searchAddress])

  const handleItemAddress = (item) => {
    const reduceFields = {
      ...delivery.customerInfo,
      all: item,
      street: item.data.street_with_type || "",
      house: item.data.house || "",
      building: item.data.block && item.data.block_type === "стр" ? item.data.block : "",
      housing: item.data.block && item.data.block_type === "к" ? item.data.block : "",
      flat: item.data.flat || "",
      city: item.data.settlement_with_type || item.data.city_with_type || "",
      region: item.data.region_with_type || "",
      metro: item.data.metro || "",
      postal_code: item.data.postal_code || "",
      floor: null,
      front_door: null,
      intercom: null,
    };

    onChangeAddress(reduceFields);
  };

  return (
    <div className="address-input">
      <InputUI
        text={text ?? 'Поиск по адресу'}
        value={localValue}
        onChange={(e) => {
          const val = e.target.value;
          setLocalValue(val);
          debouncedInput(val);
        }}
        disabled={disabled}
        options={
          debouncedValue && suggestions.length > 0 ? (
            <Suggestions
              query={debouncedValue}
              suggestions={suggestions}
              handleClick={(id) => {
                const selected = suggestions.find(s => s.id === id);
                if (selected) {
                  setLocalValue(selected.text);
                  setSuggestions([]);
                  delivery.setAddressValidShield(
                    selected.data.data.house ? '' : 'Укажите дом'
                  );
                  onChange?.(selected.text);
                  handleItemAddress(selected.data);
                }
              }}
            />
          ) : null
        }
      />
      {delivery.addressValidShield && (
        <span className="address-input__error">{delivery.addressValidShield}</span>
      )}
    </div>
  );
});

export default AddressInput;
